const MISSING = '—';

const pad = (value) => String(value).padStart(2, '0');

const isoDay = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const formatLagos = (ts, { withTime = true } = {}) => {
  if (!ts) return MISSING;
  // Never parsed as a Date: the backend sends Africa/Lagos wall-clock time with no
  // timezone marker, so any parse would silently re-read it in the browser's zone.
  const [day, time = ''] = String(ts).replace('T', ' ').split(' ');
  if (!day) return MISSING;
  return withTime && time ? `${day} ${time.slice(0, 5)}` : day;
};

export const formatUtc = (ts, { withTime = true } = {}) => {
  if (!ts) return MISSING;
  const normalized = String(ts).replace(' ', 'T');
  const parsed = new Date(normalized.endsWith('Z') ? normalized : `${normalized}Z`);
  if (Number.isNaN(parsed.getTime())) return MISSING;
  const day = `${parsed.getUTCFullYear()}-${pad(parsed.getUTCMonth() + 1)}-${pad(parsed.getUTCDate())}`;
  return withTime ? `${day} ${pad(parsed.getUTCHours())}:${pad(parsed.getUTCMinutes())}` : day;
};

const lagosClock = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Africa/Lagos',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

export const formatInstantLagos = (iso) => {
  const instant = iso ? new Date(iso) : null;
  if (!instant || Number.isNaN(instant.getTime())) return MISSING;
  const part = Object.fromEntries(lagosClock.formatToParts(instant).map(({ type, value }) => [type, value]));
  return `${part.year}-${part.month}-${part.day} ${part.hour}:${part.minute}`;
};

export const dateOnly = (ts) => (ts ? String(ts).slice(0, 10) : MISSING);

export const inDateRange = (ts, from, to) => {
  if (!ts) return !from && !to;
  const day = String(ts).slice(0, 10);
  if (from && day < String(from).slice(0, 10)) return false;
  if (to && day > String(to).slice(0, 10)) return false;
  return true;
};

export const todayISO = () => isoDay(new Date());

export const yesterdayISO = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return isoDay(date);
};
